import { render, staticRenderFns } from "./LoginAsTestator.vue?vue&type=template&id=f6d34268"
import script from "./LoginAsTestator.vue?vue&type=script&lang=js"
export * from "./LoginAsTestator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports